export const SITE = {
  name: 'Provident Palm Vista',
  domain: 'https://providentpalmvistashilphata.com',
  phoneDisplay: '+91 88798 56585',
  tel: 'tel:+918879856585',
  whatsapp: 'https://wa.me/918879856585',
  whatsappMsg:
    'Hi, I am interested in Provident Palm Vista Shilphata. Please share the latest price, floor plans and availability.',
  address:
    'Provident Palm Vista, Junction, Kalyan - Shilphata Rd, Daighar Gaon, Mumbai, Maharashtra - 421204',
  addressShort: 'Kalyan–Shilphata Road, Mumbai – 421204',
};

export const waLink = () =>
  `${SITE.whatsapp}?text=${encodeURIComponent(SITE.whatsappMsg)}`;

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ANALYTICS = {
  GA4: process.env.REACT_APP_GA4_MEASUREMENT_ID || '',
  GTM: process.env.REACT_APP_GTM_CONTAINER_ID || '',
  META: process.env.REACT_APP_META_PIXEL_ID || '',
  LEAD_ENDPOINT: process.env.REACT_APP_LEAD_FORM_ENDPOINT || '',
};
